"use client";

import React from "react";
import { Building2, Car, MapPin, Route, ShoppingBag, Utensils } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
interface UseCaseItem {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}
const USE_CASES: UseCaseItem[] = [{
  id: "hotel-to-city",
  title: "Fahrten vom Hotel in die Stadt",
  description: "Bequeme Transfers zwischen Resort-Lobbys und der Innenstadt von Hurghada oder den Marina-Bereichen.",
  icon: Building2
}, {
  id: "shopping-trips",
  title: "Einkaufsfahrten",
  description: "Flexible Hin- und Rückfahrten zu Basaren, Einkaufszentren oder Souvenirmärkten mit Warteoption.",
  icon: ShoppingBag
}, {
  id: "restaurant-evening",
  title: "Restaurant- und Abendfahrten",
  description: "Pünktliche Abholung zum Abendessen und verlässliche spätabendliche Rückfahrten zu Ihrem Resort.",
  icon: Utensils
}, {
  id: "resort-to-resort",
  title: "Transfers von Resort zu Resort",
  description: "Mühelose Verbindungen zwischen benachbarten Buchten und Hotelanlagen entlang der Küste.",
  icon: MapPin
}, {
  id: "multiple-stops",
  title: "Mehrere Zwischenstopps vor Ort",
  description: "Individuelle Routen mit mehreren Stopps für Erledigungen, Bankgeschäfte oder Besichtigungen.",
  icon: Route
}, {
  id: "short-journeys",
  title: "Kurze Punkt-zu-Punkt-Fahrten",
  description: "Schnelle, unkomplizierte Fahrten von Tür zu Tür innerhalb der Stadt mit transparenten Festpreisen vorab.",
  icon: Car
}];
export default function TaxiUseCases() {
  return <section id="localtaxiusecases" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-accent-foreground font-default">
            Wann Sie ein lokales Taxi buchen sollten
          </h2>
          <div className="w-12 h-1 bg-primary/70 rounded-full mx-auto mt-4" aria-hidden="true" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {USE_CASES.map((item, i) => {
          const IconComponent = item.icon;
          return <motion.div key={item.id} data-index={i} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: "-40px"
          }} transition={{
            duration: 0.4,
            delay: i * 0.05,
            ease: "easeOut"
          }}>
                <Card className="h-full border border-border/80 bg-card/60 backdrop-blur-xs rounded-xl shadow-xs transition-all duration-200 hover:-translate-y-1 hover:shadow-md hover:border-primary/40 p-5 md:p-6 gap-3">
                  <CardHeader className="p-0 gap-3">
                    <div className="size-11 rounded-lg bg-accent/60 flex items-center justify-center text-primary ring-1 ring-primary/20 shrink-0">
                      <IconComponent className="size-5" aria-hidden="true" />
                    </div>
                    <CardTitle className="text-lg font-semibold text-accent-foreground font-default">
                      <h3 className="leading-snug">{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}